import { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import success from "src/images/success.png";
import axiosServices from 'src/Services/axiosServices';
import styles from "./styles.module.css";


const EmailVerify = () => {

    type validationState = "waiting" | "valid" | "invalid";

    enum validState {
        waiting,
        valid,
        invalid,
    }

    const [ isValid, setValidUrl ] = useState<validState>(validState.waiting);
    const params = useParams();
    const [ msg, setMsg ] = useState(null);
    const [ error, seterror ] = useState(null);
    const [ loginTo, setLoginTo ] = useState('');
    const {search} = useLocation();
    const parameters = new URLSearchParams(search);

    useEffect(() => {

        const verifyEmailUrl = async () => {
            console.log('verifyEmailUrl')
            console.log(parameters)
            try {
                const {data} = await axiosServices.ValidateEmail(parameters.get('token') ?? "<NULL>");
                console.log(data);
                setMsg(data.msg);
                setLoginTo(data.data.username)
                setValidUrl(validState.valid);
            } catch (error: any) {
                console.log(`Erreur : `);
                console.log(error?.response?.data);
                setMsg(error?.response?.data);
                seterror(error?.message)
                setValidUrl(validState.invalid);
            }
        };
        verifyEmailUrl().then();
    }, [ parameters ]);

    return (
        <Fragment>
            {isValid === validState.valid ? (
                <div className={styles.container}>
                    <img src={success} alt="success_img" className={styles.success_img}/>
                    <h1>{msg}</h1>
                    <Link to="/Login">
                        <button className={styles.green_btn}>Login {loginTo}</button>
                    </Link>
                </div>
            ) : (
                isValid === validState.invalid ? (
                    <div>
                        <h1>{error}</h1>
                        <h2>{msg}</h2>
                    </div>
                ) : (<h1>Veuillez patienter, votre adresse mail est en cours de validation.</h1>)
            )
            }
        </Fragment>
    );
};

export default EmailVerify;
